// eslint-disable-next-line import/default
import detailsMixin from './detailsMixin';
import get from 'lodash/get';
import size from 'lodash/size';
import startsWith from 'lodash/startsWith';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsForm',
  mixins: [detailsMixin],
  data: function () {
    return {};
  },
  methods: {
    get,
    size,
    startsWith
  }
};